let DISABLE = false;
// DISABLE = true;

import React from "react";
import { View } from "react-native";
import ENV from "app/utils/ENV";

import { Hoverable as HoverableHook } from "react-native-web-hooks";

export default class Hoverabl extends React.Component {
  constructor(props) {
    super(props);
    let defaultDelay = 700;
    let delay = props.delay == true ? defaultDelay : props.delay;
    this.state = {
      isHovered: false,
      delay,
      stickyHovered: false,
      // stickOnClick: ENV.WEB ? this.props.stickOnClick : true,
      delaying: false,
    };
  }

  componentDidMount() {
    if (ENV.WEB && !DISABLE)
      document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    if (ENV.WEB && !DISABLE)
      document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = () => {
    if (this.state.isHovered) {
      this.setState({ isHovered: false });
      this.props.onHoverOut && this.props.onHoverOut();
    }
  };

  render() {
    let { children, onHoverIn, onHoverOut } = this.props;
    if (DISABLE) return typeof children == "function" ? children() : children;
    let { isHovered, delay, stickyHovered } = this.state;
    if (stickyHovered) isHovered = true;

    // if (stickOnClick) {
    //   Wrapper = TouchableOpacity;
    //   onPress = () =>
    //     this.setState({ stickyHovered: !this.state.stickyHovered });
    // }

    return (
      <HoverableHook
        onHoverIn={() => {
          this.setState({ isHovered: true });
          if (!!delay) {
            this.setState({ delaying: true });
            this.delayTimeout = setTimeout(() => {
              this.setState({ delaying: false });
              onHoverIn && onHoverIn();
            }, delay);
          } else {
            onHoverIn && onHoverIn();
          }
        }}
        onHoverOut={() => {
          this.setState({ isHovered: false });
          if (this.delayTimeout) clearTimeout(this.delayTimeout);
          this.setState({ delaying: false });
          onHoverOut && onHoverOut();
        }}
      >
        {(() => {
          // HoverableHook does React.Children.only(child) — an array of
          // children (or a null) crashes the whole page, so normalize to a
          // single element
          let resolved =
            typeof children == "function" ? children(isHovered) : children;
          if (Array.isArray(resolved) || !React.isValidElement(resolved)) {
            return <View>{resolved}</View>;
          }
          return resolved;
        })()}
      </HoverableHook>
    );
  }
}
